import React from 'react';
import { AuthComponent } from '@trustpilot/ecommscript-integrationappauth';
import { connect } from 'react-redux';
import { FirebaseConfiguration } from './utils/firebaseConfiguration';
import {
  shop as shopActions,
  pricing as pricingActions,
  businessModule as businessModuleActions,
  trustpilot as trustpilotActions,
  analytics as analyticsActions,
} from './actions';

const Auth: React.FC<any> = (props) => {
  const onLoggedInChange = (value: boolean) => {
    props.setLoggedStatus(value);
    props.getPricing();
    props.getId();
    props.getStoreDetails();
  };
  const trackLink = (data: any) => {
    props.track('Integration Link Clicked', {
      context: 'Ecommscript integration app',
      location: window.location.pathname,
      integration: 'Shopify',
      ...data,
    });
  };

  const trackButton = (data: any) => {
    props.track('Integration Button Clicked', {
      context: 'Ecommscript integration app',
      location: window.location.pathname,
      integration: 'Shopify',
      ...data,
    });
  };
  return (
    <AuthComponent
      onLoggedIn={onLoggedInChange}
      source="Shopify"
      forgotPasswordUrl={process.env.REACT_APP_ForgotPasswordUrl!}
      cookiesDomain={process.env.REACT_APP_CookiesDomain!}
      authenticationApiUrl={process.env.REACT_APP_AuthenticationApiUrl!}
      simplicityUrl={process.env.REACT_APP_SimplicityUrl!}
      settingsApiUrl={process.env.REACT_APP_SettingsApiUrl!}
      integrationConfig={{}}
      trackLink={trackLink}
      trackButton={trackButton}
      firebaseOptions={FirebaseConfiguration}
    />
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  setLoggedStatus: (value: boolean) => dispatch(trustpilotActions.setLoggedStatus(value)),
  getStoreDetails: () => dispatch(shopActions.getStoreDetails()),
  getPricing: () => dispatch(pricingActions.getPricing()),
  getId: () => dispatch(businessModuleActions.getId()),
  track: (name: string, data: any) => dispatch(analyticsActions.track(name, data)),
});

export default connect(null, mapDispatchToProps)(Auth);
